module.exports = __webpack_public_path__ + "img/settings.2a8900c0.svg";